module.exports = __webpack_public_path__ + "static/media/story_17.6ec7b39d.jpg";